/**
 * @generated SignedSource<<40bed2e0df22333eaace2ce042dfb37a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WatchStreamToggleMutation$variables = {
  id: string;
  watching: boolean;
};
export type WatchStreamToggleMutation$data = {
  readonly noteStreamToggleWatch: {
    readonly noteStream: {
      readonly id: string;
      readonly watching: boolean | null;
    };
  } | null;
};
export type WatchStreamToggleMutation$rawResponse = {
  readonly noteStreamToggleWatch: {
    readonly noteStream: {
      readonly id: string;
      readonly watching: boolean | null;
    };
  } | null;
};
export type WatchStreamToggleMutation = {
  rawResponse: WatchStreamToggleMutation$rawResponse;
  response: WatchStreamToggleMutation$data;
  variables: WatchStreamToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "watching"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "watching",
        "variableName": "watching"
      }
    ],
    "concreteType": "NoteStreamToggleWatch",
    "kind": "LinkedField",
    "name": "noteStreamToggleWatch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "watching",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WatchStreamToggleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchStreamToggleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "50f3939eb428f7bd66a37fd57bd030db",
    "id": null,
    "metadata": {},
    "name": "WatchStreamToggleMutation",
    "operationKind": "mutation",
    "text": "mutation WatchStreamToggleMutation(\n  $id: ID!\n  $watching: Boolean!\n) {\n  noteStreamToggleWatch(id: $id, watching: $watching) {\n    noteStream {\n      id\n      watching\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "68c97b28b886da13e79079f8ad2f0d1d";

export default node;
